import type { BrandConfig } from '../constants/brands/types';

/**
 * Brand-aware Sentry client options (W12, launch 8.3).
 *
 * Autopilotee keeps Session Replay and default PII. Lenvoy turns both off so
 * guest sessions are not recorded into Autopilotee's Sentry project.
 */
export type SentryBrandOptions = {
  brandSite: string;
  sendDefaultPii: boolean;
  enableSessionReplay: boolean;
  replaysSessionSampleRate: number;
  replaysOnErrorSampleRate: number;
};

export function sentryBrandOptions(
  brand: Pick<BrandConfig, 'id' | 'brandSite'>,
): SentryBrandOptions {
  const isLenvoy = brand.id === 'lenvoy' || brand.brandSite === 'lenvoy.co';
  if (isLenvoy) {
    return {
      brandSite: brand.brandSite,
      sendDefaultPii: false,
      enableSessionReplay: false,
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 0,
    };
  }
  return {
    brandSite: brand.brandSite,
    sendDefaultPii: true,
    enableSessionReplay: true,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  };
}
